// https://codesandbox.io/s/jpo114rk6v?file=/index.js for multiple images

import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import styled from 'styled-components';

const Thumb = styled.div`
  width: 100%;
  height: 100%;
`;

const ThumbInner = styled.div`
  overflow: hidden;
`;

const Image = styled.img`
  width: auto;
  height: 100px;
`;

const DropzoneWrapper = styled.section`
  width: ${(props) => (props.hasHalfWidth ? '50%' : '100%')};
  .dropzone {
    border: 1px solid ${(props) => props.theme.borderColor};
    background-color: ${(props) => props.theme.secondaryColor};
  }

  figure {
    margin: auto;
  }
`;

const Label = styled.label`
  font-size: ${(props) => props.theme.fontSizeSmall};
`;

const uploadFileIcon = (
  <svg
    width="98"
    height="98"
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M78.5615 39.3441H70.2034C69.4645 39.3441 68.7559 39.6376 68.2334 40.1601C67.7109 40.6826 67.4174 41.3912 67.4174 42.1301C67.4174 42.869 67.7109 43.5776 68.2334 44.1001C68.7559 44.6226 69.4645 44.9161 70.2034 44.9161H78.5615V75.5623H11.697V44.9161H20.0551C20.794 44.9161 21.5026 44.6226 22.0251 44.1001C22.5476 43.5776 22.8411 42.869 22.8411 42.1301C22.8411 41.3912 22.5476 40.6826 22.0251 40.1601C21.5026 39.6376 20.794 39.3441 20.0551 39.3441H11.697C10.2198 39.3458 8.80348 39.9334 7.75888 40.978C6.71429 42.0226 6.1267 43.4388 6.125 44.9161V75.5623C6.1267 77.0396 6.71429 78.4559 7.75888 79.5005C8.80348 80.5451 10.2198 81.1327 11.697 81.1344H78.5615C80.0388 81.1327 81.455 80.5451 82.4996 79.5005C83.5442 78.4559 84.1318 77.0396 84.1335 75.5623V44.9161C84.1318 43.4388 83.5442 42.0226 82.4996 40.978C81.455 39.9334 80.0388 39.3458 78.5615 39.3441Z"
      fill="#757575"
    />
    <path
      d="M30.3826 24.5978L42.343 12.6377V67.2043C42.343 67.9432 42.6365 68.6519 43.159 69.1744C43.6815 69.6968 44.3901 69.9904 45.129 69.9904C45.8679 69.9904 46.5766 69.6968 47.0991 69.1744C47.6215 68.6519 47.9151 67.9432 47.9151 67.2043V12.6377L59.8754 24.5978C60.4009 25.1052 61.1046 25.3861 61.8351 25.3797C62.5656 25.3734 63.2644 25.0804 63.7809 24.5638C64.2975 24.0473 64.5905 23.3485 64.5968 22.618C64.6032 21.8875 64.3224 21.1838 63.8149 20.6583C63.2256 20.0688 47.6225 4.4501 47.0152 3.88649C46.491 3.3938 45.7958 3.12417 45.0765 3.13457C44.3572 3.14496 43.6701 3.43458 43.1604 3.94221L26.4443 20.6583C25.9426 21.1848 25.6666 21.8865 25.6753 22.6137C25.684 23.3409 25.9767 24.0358 26.4908 24.5501C27.005 25.0644 27.6999 25.3573 28.427 25.3662C29.1542 25.3751 29.8561 25.0993 30.3826 24.5978Z"
      fill="#757575"
    />
  </svg>
);

const uploadImageIcon = (
  <svg
    width="89"
    height="79"
    viewBox="0 0 89 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.5447 31.6765C36.9216 31.6765 39.6592 28.939 39.6592 25.562C39.6592 22.1851 36.9216 19.4475 33.5447 19.4475C30.1677 19.4475 27.4302 22.1851 27.4302 25.562C27.4302 28.939 30.1677 31.6765 33.5447 31.6765Z"
      fill="#757575"
    />
    <path
      d="M83.7347 48.0668C80.8473 45.3492 77.1956 43.5658 73.2042 43.0563V11.9742C73.2042 8.66221 71.8454 5.68989 69.7223 3.48187C67.5143 1.27386 64.542 0 61.23 0H11.9742C8.66221 0 5.68989 1.35878 3.48187 3.48187C1.27385 5.68989 0 8.66221 0 11.9742V51.124V54.7758V62.6737C0 65.9857 1.35878 68.958 3.48187 71.166C5.68989 73.374 8.66221 74.6479 11.9742 74.6479H59.6164C62.7586 77.1956 66.6651 78.8092 70.9962 78.8092C76.0067 78.8092 80.5076 76.771 83.7347 73.5439C86.9618 70.3168 89 65.8158 89 60.8053C89 55.7948 86.9618 51.2939 83.7347 48.0668ZM4.50095 11.9742C4.50095 9.93607 5.35019 8.06775 6.70897 6.79389C8.06775 5.43511 9.93607 4.58588 11.9742 4.58588H61.23C63.2681 4.58588 65.1365 5.43511 66.4952 6.79389C67.854 8.15267 68.7032 10.021 68.7032 12.0592V38.5553L56.1345 25.9866C55.2853 25.1374 53.8416 25.0525 52.9074 25.9866L33.9695 45.0095L21.146 32.1011C20.2968 31.2519 18.8531 31.167 17.9189 32.1011L4.50095 45.6889V11.9742ZM11.8893 70.3168V70.1469C9.85114 70.1469 7.98282 69.2977 6.62405 67.9389C5.35019 66.5801 4.50095 64.7118 4.50095 62.6737V54.7758V52.1431L19.5324 37.0267L32.3559 49.8502C33.2052 50.6994 34.6489 50.6994 35.583 49.8502L54.521 30.8273L66.9198 43.3111C66.6651 43.396 66.4103 43.4809 66.1555 43.5658C65.8158 43.6508 65.4761 43.7357 65.0515 43.9055C64.7118 43.9905 64.3721 44.1603 64.0324 44.2452C63.7777 44.3302 63.6078 44.4151 63.3531 44.5849C63.0134 44.7548 62.7586 44.8397 62.5038 45.0095C62.0792 45.2643 61.6546 45.5191 61.23 45.7739C60.9752 45.9437 60.8053 46.0286 60.5506 46.1985C60.3807 46.2834 60.2958 46.3683 60.126 46.4532C59.3616 46.9628 58.6823 47.5573 58.0878 48.2366C54.8607 51.4637 52.8225 55.9647 52.8225 60.9752C52.8225 62.249 52.9924 63.438 53.2471 64.7118C53.3321 65.0515 53.417 65.3063 53.5019 65.646C53.7567 66.4952 54.0114 67.3445 54.3511 68.1937V68.2786C54.6908 68.958 55.0305 69.7223 55.4552 70.3168H11.8893ZM80.4227 70.3168C77.9599 72.7796 74.6479 74.2233 70.9113 74.2233C67.3445 74.2233 64.0324 72.7796 61.6546 70.4866C61.3149 70.1469 60.9752 69.7223 60.6355 69.3826C60.3807 69.1279 60.126 68.7882 59.8712 68.5334C59.5315 68.1088 59.2767 67.5992 59.0219 67.0897C58.8521 66.75 58.6823 66.4952 58.5124 66.1555C58.3426 65.7309 58.1727 65.2214 58.0878 64.7118C58.0029 64.3721 57.833 63.9475 57.7481 63.6078C57.5782 62.7586 57.4933 61.8244 57.4933 60.8903C57.4933 57.1536 59.0219 53.8416 61.3998 51.3788C63.7777 48.916 67.1746 47.4723 70.9113 47.4723C74.6479 47.4723 77.9599 49.001 80.4227 51.3788C82.8855 53.8416 84.3292 57.1536 84.3292 60.8903C84.3292 64.542 82.8006 67.854 80.4227 70.3168Z"
      fill="#757575"
    />
    <path
      d="M72.5248 51.7186C72.355 51.5487 72.1002 51.3789 71.7605 51.209C71.5057 51.1241 71.2509 51.0392 70.9962 51.0392C70.9112 51.0392 70.9112 51.0392 70.9112 51.0392C70.8263 51.0392 70.8263 51.0392 70.8263 51.0392C70.5716 51.0392 70.3168 51.1241 70.062 51.209C69.8072 51.294 69.5525 51.4638 69.2977 51.7186L64.0324 56.9838C63.1832 57.8331 63.1832 59.2768 64.0324 60.2109C64.8817 61.0602 66.3254 61.0602 67.2595 60.2109L68.6183 58.8522V68.1938C68.6183 69.4676 69.6374 70.4867 70.9112 70.4867C72.1851 70.4867 73.2042 69.4676 73.2042 68.1938V58.8522L74.563 60.2109C75.4122 61.0602 76.8559 61.0602 77.7901 60.2109C78.6393 59.3617 78.6393 57.918 77.7901 56.9838L72.5248 51.7186Z"
      fill="#757575"
    />
  </svg>
);

const Dropzone = ({ label, title, hasHalfWidth }) => {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      );
    },
  });

  const thumbs = files.map((file) => (
    <Thumb key={file.name}>
      <ThumbInner>
        <Image src={file.preview} alt="images" />
      </ThumbInner>
    </Thumb>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  return (
    <DropzoneWrapper className="field" hasHalfWidth={hasHalfWidth}>
      <Label className="label has-text-weight-semibold mb-2 has-text-black">
        {label}
      </Label>
      <div
        {...getRootProps({
          className: 'control dropzone p-5',
        })}>
        <input {...getInputProps()} />
        <div className="columns is-vcentered">
          <div className="column ">{uploadImageIcon || uploadFileIcon}</div>
          <div className="column">
            <h3 className="is-size-4 has-text-centered-mobile">
              {title || 'Upload photos'}
            </h3>
          </div>
        </div>
      </div>
      <aside className="mt-4">{thumbs}</aside>
    </DropzoneWrapper>
  );
};

export default Dropzone;
